const U = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}&auto=format`;

export const IMAGES = {
  hero: U("photo-1712561854810-631421883c24", 2000),
  spiceMarket: U("photo-1785107743014-6cf50aa8e169", 1800),
  spiceBaskets: U("photo-1649053930596-29cb47828d87", 1400),
  dubaiPort: U("photo-1726231042633-7d36929122e3", 1800),
  dubaiSkyline: U("photo-1512453979798-5ea266f8880c", 1600),
  containers: U("photo-1494412574643-ff11b0a5c1c3", 1800),
  wheat: U("photo-1574323347407-f5e1ad6d020b", 1400),
};

export const PRODUCTS = [
  { id: "cereals", key: "cereals", tag: "01", nameEn: "Cereals", img: U("photo-1586201375761-83865001e31c", 1200) },
  { id: "spices", key: "spices", tag: "02", nameEn: "Spices", img: U("photo-1596040033229-a9821ebd058d", 1200) },
  { id: "pulses", key: "pulses", tag: "03", nameEn: "Pulses", img: U("photo-1651981350249-6173caeeb660", 1200) },
  { id: "agro", key: "agro", tag: "04", nameEn: "Agro Commodities", img: U("photo-1574323347407-f5e1ad6d020b", 1200) },
  { id: "nuts", key: "nuts", tag: "05", nameEn: "Nuts", img: U("photo-1600188999986-331bec5f9a8d", 1200) },
  { id: "dry-fruits", key: "dryFruits", tag: "06", nameEn: "Dry Fruits", img: U("photo-1583126379180-ec70bb3178b1", 1200) },
];

export const ROUTES = [
  { to: "/", key: "home" },
  { to: "/about", key: "about" },
  { to: "/products", key: "products" },
  { to: "/import-sourcing", key: "sourcing" },
  { to: "/export", key: "export" },
  { to: "/global-reach", key: "reach" },
  { to: "/contact", key: "contact" },
];

export const CONTACT = {
  phone: "+971 50 379 2861",
  phoneHref: "tel:+971503792861",
  whatsapp:
    "https://wa.me/971503792861?text=Hello%20Al%20Nama%20Importer%2C%20I%20would%20like%20to%20discuss%20a%20trading%20requirement.",
  email: "sales@alnamaimporter.com",
  emailHref: "mailto:sales@alnamaimporter.com",
  address: "Compass Building, Al Hamra Industrial Zone, Ras Al Khaimah, UAE",
  addressAr: "مبنى كومباس، منطقة الحمرا الصناعية، رأس الخيمة، الإمارات العربية المتحدة",
  company: "Al Nama Importer",
  companyAr: "النعم للاستيراد",
};

export const INDIA_OFFICE = {
  label: "Global Impex International",
  address: "402, 4th Floor, Suncity Trade Tower, Sector 21, Gurugram - 122016",
  addressAr: "402، الطابق الرابع، برج سن سيتي تريد، القطاع 21، غوروغرام - 122016",
  phone: "+91 92665 07476",
  phoneHref: "tel:+919266507476",
  whatsapp:
    "https://wa.me/919266507476?text=Hello%20Global%20Impex%20International%2C%20I%20would%20like%20to%20discuss%20a%20sourcing%20requirement.",
  poc: "Vishal Kumar",
  pocAr: "فيشال كومار",
};
